import { MarketingChannel } from "@redotech/redo-model/marketing";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const setCustomerSubscribed = {
  name: "setCustomerSubscribed" as const,
  input: z.object({
    customerId: zExt.objectId(),
    action: createEnum(["subscribe", "unsubscribe"]),
    channel: createEnum(MarketingChannel),
  }),
  output: z.object({}),
};
